import { use } from 'react';
import { useSessionStorage } from 'usehooks-ts';
import FilterSessionStorageKeys from 'shared/constants/filterSessionStorageKeys';
import ObjectSort from 'shared/models/object-sort';
import DevicesProviderContext from 'shared/providers/devices/contexts/devices-provider-context';

import Device from 'features/device/domain/models/device';
import DeviceFilterValues from 'features/device/models/device-filter-values';

export interface IDevicesHook {
  openDeviceDetailsPopup: (isOpenedFromOrganisationUnit: boolean) => void;
  closeDeviceDetailsPopup: () => void;
  isDeviceDetailsPopupOpen: boolean;
  isDeviceDetailsPopupOpenedFromOrganisationDetailView: boolean;
  deviceFiltersFromSessionStorage: DeviceFilterValues;
  setDeviceFiltersFromSessionStorage: (filters: DeviceFilterValues) => void;
  sortFromSessionStorage: ObjectSort<Device>;
  setSortFromSessionStorage: (sort: ObjectSort<Device>) => void;
  searchBarFromSessionStorage: string;
  setSearchBarFromSessionStorage: (searchBar: string) => void;
}

export const useDevices = (): IDevicesHook => {
  const [deviceFiltersFromSessionStorage, setDeviceFiltersFromSessionStorage] = useSessionStorage<DeviceFilterValues>(
    FilterSessionStorageKeys.DEVICES_FILTERS,
    {
      filterValues: [],
      monitoringFilterValues: [],
    },
  );
  const [sortFromSessionStorage, setSortFromSessionStorage] = useSessionStorage<ObjectSort<Device>>(
    FilterSessionStorageKeys.DEVICES_SORTING,
    {
      property: 'name',
      isAscending: true,
    },
  );
  const [searchBarFromSessionStorage, setSearchBarFromSessionStorage] = useSessionStorage<string>(
    FilterSessionStorageKeys.DEVICES_SEARCH_BAR,
    '',
  );

  const { openPopup, closePopup, isPopupOpen, allowUnlinking } = use(DevicesProviderContext);

  const openDeviceDetailsPopup = (isOpenedFromOrganisationUnit: boolean) => openPopup(!isOpenedFromOrganisationUnit);

  const closeDeviceDetailsPopup = (): void => closePopup();

  return {
    openDeviceDetailsPopup,
    closeDeviceDetailsPopup,
    isDeviceDetailsPopupOpen: isPopupOpen,
    isDeviceDetailsPopupOpenedFromOrganisationDetailView: allowUnlinking,
    deviceFiltersFromSessionStorage,
    setDeviceFiltersFromSessionStorage,
    sortFromSessionStorage,
    setSortFromSessionStorage,
    searchBarFromSessionStorage,
    setSearchBarFromSessionStorage,
  };
};
